import { select } from '../shared/utils/dom';
import { delimiters } from '../shared/constants';
import loadingMixin from '../shared/vue/mixins/loading';
import scrollUp from '../shared/vue/mixins/scrollUp';
import { regex } from '../shared/constants/validation';
import { createError, removeError } from '../shared/formErrors';

const cssCheckmarkIcon = 'js-checkmark-icon';
const cssStopIcon = 'js-stop-icon';
/*
* Enroll in paperless billing
*/
const el = select('[data-vue-app="forgot-username"]');
if (el) {
  const app = new Vue({ // eslint-disable-line no-unused-vars
    el,
    mixins: [loadingMixin, scrollUp],
    delimiters,
    data: {
      // for accessibility in live regions
      liveText: '',
      success: false,
      numberOfEmails: 3,
      emails: [],
    },
    mounted() {
      this.numberOfEmails = (this.$el.dataset && this.$el.dataset.numberOfEmails) ? JSON.parse(this.$el.dataset.numberOfEmails) : 3;
      this.emails = new Array(this.numberOfEmails);
      setTimeout(() => {
        if (document.querySelector("input.js-with-icon")) {
          document.querySelector("input.js-with-icon").focus();
          document.querySelector("input.js-with-icon").blur();
          document.querySelector("input.js-with-icon").classList.remove(cssCheckmarkIcon);
        }
      }, 500);
    },

    /**
     * Computed
     */
    computed: {
      /**
       * Disable the "Submit" button without valid email
       * @return {boolean}
       */
      shouldBeDisabled() {
        if (this.numberOfEmails > 0) {
          const validEmails = this.emails.filter(email => (email !== "" && regex.email.test(email.trim())));
          const inValidEmails = this.emails.filter(email => !(email === "" || regex.email.test(email.trim())));
          return (validEmails.length === 0 || inValidEmails.length > 0);
        }
        return true;
      },
    },

    /**
     * Methods
     */
    methods: {
      sendForgottenUsername() {
        this.loading = true;
        if (window.fabricator) {
          setTimeout(() => {
            this.$refs.formHeadline.style.display = 'none';
            this.$refs.forgotUsernameForm.style.display = 'none';
            this.loading = false;
            this.success = true;
            this.scrollUp();
          }, 500);
        }
      },
      checkEmail(e) {
        const element = e.target;
        element.classList.remove(cssCheckmarkIcon);
        if (!element.value || regex.email.test(element.value.trim())) {
          removeError(element, element.nextElementSibling);
          element.classList.remove(cssStopIcon);
          if (element.value) {
            element.classList.add(cssCheckmarkIcon);
          }
        } else if (!element.className.includes("js-has-error")) {
          createError(element, element.nextElementSibling, 'Make sure you enter a valid email address.');
          element.classList.add(cssStopIcon);
        }
        element.value = element.value.trim();
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/forgotUsername.js